/**
 * Die Prioritätsauswahl im Sheet `task-sheet` (`task-priority`, Spec 06a,
 * „Felder in Reihenfolge": „vorbelegt „Normal""). Dieselbe Bauform wie
 * `TaskStatusField` — Optionen von `GET /tickets/priorities`, keine eigene
 * Zuordnung von Werten auf deutsche Bezeichnungen (AK-394).
 */

import { useTicketPriorities } from '@/features/tasks/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface TaskPriorityFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
}

export function TaskPriorityField({ testId, errorPrefix, value, onChange, error }: TaskPriorityFieldProps) {
  const prioritiesQuery = useTicketPriorities()

  return (
    <EnumSelectField
      label="Priorität"
      testId={testId}
      apiField="priority"
      errorPrefix={errorPrefix}
      options={prioritiesQuery.data ?? []}
      isPending={prioritiesQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      required
    />
  )
}
